import { Howl } from 'howler';

/**
 * SoundFont player using Howler.js audio sprites.
 * Conforms to soundfont JSON spritemap specification.
 */
export class SoundFont {
  constructor(spriteConfig, onReady) {
    this.loaded = false;
    this.howl = null;

    if (!spriteConfig) {
      console.warn('SoundFont: No sprite configuration provided.');
      return;
    }

    try {
      // Build Howl sprite definition from soundfont JSON:
      // In Howler, sprite format is: { [name]: [offsetMs, durationMs, loopBool?] }
      const spriteObj = {};
      const spritemap = spriteConfig.spritemap || {};

      for (const [key, item] of Object.entries(spritemap)) {
        const startMs = Math.round(item.start * 1000);
        const durationMs = Math.round((item.end - item.start) * 1000);
        spriteObj[key] = [startMs, durationMs, !!item.loop];
      }

      const resources = spriteConfig.resources || [
        'assets/audio/sfx/soundfont.mp3',
        'assets/audio/sfx/soundfont.wav',
      ];

      this.howl = new Howl({
        src: resources,
        sprite: spriteObj,
        volume: 0.7,
        onload: () => {
          this.loaded = true;
          console.log('Commodore 64 SoundFont loaded successfully via Howler.js');
          if (onReady) onReady();
        },
        onloaderror: (id, err) => {
          console.warn('SoundFont audio file not yet loaded; using SID chip synth fallback', err);
        },
      });
    } catch (e) {
      console.warn('Error initializing Howler SoundFont', e);
    }
  }

  play(soundName) {
    if (this.loaded && this.howl) {
      try {
        this.howl.play(soundName);
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  setVolume(vol) {
    if (this.howl) {
      this.howl.volume(vol);
    }
  }

  setMute(mute) {
    if (this.howl) {
      this.howl.mute(mute);
    }
  }
}
